import styled from 'styled-components';

import colors from 'app/styles/theme/colors';
import {
  radii,
  spacing,
  fontSizes,
} from 'app/components/customers/styles/scales';

const { gray, green } = colors.designSystem;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin: 0 auto ${spacing[16]};
  border-radius: ${radii.full};
  background: ${green[100]};
  color: ${green[600]};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Title = styled.h2`
  font-size: ${fontSizes[20]};
  font-weight: 700;
  color: ${gray[950]};
  text-align: center;
  margin: 0 0 ${spacing[8]};
`;

export const Description = styled.p`
  font-size: ${fontSizes[14]};
  color: ${gray[700]};
  text-align: center;
  margin: 0 0 ${spacing[24]};
  line-height: 1.5;
`;

export const CopyButton = styled.button`
  width: 100%;
  padding: ${spacing[12]} ${spacing[16]};
  border: 1px solid ${green[500]};
  border-radius: ${radii.small};
  background: ${green[50]};
  color: ${green[600]};
  font-size: ${fontSizes[14]};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover:not(:disabled) {
    background: ${green[100]};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DeadlineNotice = styled.p`
  font-size: ${fontSizes[13]};
  color: ${gray[600]};
  text-align: center;
  margin: ${spacing[16]} 0 0;
`;

export const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${spacing[16]};

  img {
    width: 220px;
    height: 220px;
    object-fit: contain;
  }
`;

export const ConfirmButton = styled.button`
  width: 100%;
  margin-top: ${spacing[24]};
  padding: ${spacing[12]} ${spacing[16]};
  border: none;
  border-radius: ${radii.small};
  background: ${green[500]};
  color: ${gray[0]};
  font-size: ${fontSizes[16]};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background: ${green[600]};
  }
`;

export const LineField = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[8]};
  padding: ${spacing[12]};
  border: 1px solid ${gray[250]};
  border-radius: ${radii.small};
  background: ${gray[100]};
  color: ${gray[950]};
  font-size: ${fontSizes[13]};
  word-break: break-all;
  margin-bottom: ${spacing[16]};
`;

export const ButtonsRow = styled.div`
  display: flex;
  gap: ${spacing[12]};
  margin-top: ${spacing[24]};
`;

export const ViewBoletoButton = styled.button`
  flex: 1;
  padding: ${spacing[12]} ${spacing[16]};
  border: none;
  border-radius: ${radii.small};
  background: ${green[500]};
  color: ${gray[0]};
  font-size: ${fontSizes[14]};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover:not(:disabled) {
    background: ${green[600]};
  }

  &:disabled {
    background: ${gray[200]};
    color: ${gray[600]};
    cursor: not-allowed;
  }
`;

export const CloseButton = styled.button`
  flex: 1;
  padding: ${spacing[12]} ${spacing[16]};
  border: 1px solid ${gray[250]};
  border-radius: ${radii.small};
  background: ${gray[0]};
  color: ${gray[950]};
  font-size: ${fontSizes[14]};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background: ${gray[100]};
  }
`;
